export default {
  header: {
    home: 'Accueil',
    categories: 'Catégories',
    about: 'À propos',
    searchPlaceholder: 'Rechercher des jeux...',
    toggleDarkMode: 'Basculer le mode sombre',
    toggleLightMode: 'Basculer le mode clair',
    changeLanguage: 'Changer la langue'
  },
  nav: {
    home: 'Accueil',
    categories: 'Catégories',
    popular: 'Populaire',
    favorites: 'Favoris',
    search: 'Rechercher...',
    login: 'Connexion',
    register: 'Inscription',
    myProfile: 'Mon Profil',
    settings: 'Paramètres',
    logout: 'Déconnexion',
    darkMode: 'Mode Sombre',
    lightMode: 'Mode Clair',
    language: 'Langue',
    about: 'À propos'
  },
  footer: {
    about: 'À propos de nous',
    contact: 'Contact',
    contactUs: 'Contactez-nous',
    policy: 'Politique de confidentialité',
    terms: 'Conditions d\'utilisation',
    copyright: '© {year} GoGameVault. Tous droits réservés.',
    playOnline: 'Jouer en ligne',
    bestGames: 'Meilleurs jeux',
    newGames: 'Nouveaux jeux',
    popularGames: 'Jeux populaires',
    followUs: 'Suivez-nous',
    disclaimer: 'Tous les jeux appartiennent à leurs créateurs originaux. Nous ne revendiquons aucun droit sur eux.',
    introText: 'La meilleure plateforme de jeux en ligne gratuits. Pas de téléchargement, pas d\'inscription, que du plaisir !',
    quickLinks: 'Liens rapides',
    popularCategories: 'Catégories populaires',
    contactText: 'Des questions, des suggestions ou des commentaires ? Nous aimerions avoir votre avis !',
    aboutUs: 'À propos de nous'
  },
  gameCard: {
    play: 'Jouer maintenant',
    new: 'Nouveau',
    popular: 'Populaire'
  },
  shareButtons: {
    share: 'Partager',
    copyLink: 'Copier le lien',
    facebook: 'Partager sur Facebook',
    twitter: 'Partager sur Twitter',
    whatsapp: 'Partager sur WhatsApp',
    telegram: 'Partager sur Telegram',
    copied: 'Copié !'
  },
  searchBar: {
    search: 'Rechercher',
    placeholder: 'Trouvez vos jeux préférés...'
  },
  share: {
    title: 'Partager',
    copy: 'Copier le lien',
    copied: 'Copié',
    instagramNotSupported: 'Instagram ne prend pas en charge le partage direct de liens'
  },
  defaultGameImage: {
    text: 'Image du jeu'
  }
}; 